// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f4588d0b","513":"cca74e98","703":"e2ffc4a0","787":"d653e850"}[chunkId] + ".chunk.js";
};